@app.controller 'JouleLandingHeroController', ($element, $rootScope, LocationService, responsiveService, $window, mobileDetectionService, MetadataService, ShopifyService) ->
  @content =
    title: "Joule. Your Next Kitchen Essential."
    description: "Sign up, and be the first to know when Joule goes back on sale later this fall."
    image: 'https://d3awvtnmmsvyot.cloudfront.net/api/file/LHLAwBpQvGfv281fldum'
    mobileImage: 'https://d3awvtnmmsvyot.cloudfront.net/api/file/ymSFiIwTQmqHYBTdK2Lk'
    youtubeId: 'QBjjIWMYH8s'
    international:
      title: 'Joule.'
      subtitle: 'Perfect food. Every time.'
      description: 'Available outside the US starting in late 2016. Stay tuned for updates on special pricing for international community members.'
  @theme = 'light'

  @product = ShopifyService.productForSku 'cs10001'
  @price = @product.price
  @inStock = false

  if @product.inventory_quantity > 0
    @inStock = true
  else
    @inStock = false

  @getAspect = ->
    return 'portrait' if ($element.children()[0].clientHeight / 9) > ($element.children()[0].clientWidth / 16)
    return 'landscape'

  @isVideoVisible = false

  @showVideo = =>
    @isVideoVisible = true
    $rootScope.$broadcast 'nav.hideNav', @isVideoVisible

  @hideVideo = =>
    @isVideoVisible = false
    $rootScope.$broadcast 'nav.hideNav', @isVideoVisible

  @handleEmbedVideoClicked = => @hideVideo()

  # Set Location
  @isInUS = LocationService.isInUS()

  # Responsive Variables
  @isViewportMobile = responsiveService.isViewportMobile()
  @isMobileDevice = mobileDetectionService.isMobile
  @responsiveWidth = responsiveService
  angular.element($window).bind 'resize', =>
    @isViewportMobile = responsiveService.isViewportMobile()
    $rootScope.$safeApply()

  # SEO Metadata
  canonical = '/joule'
  title = 'Joule: Sous Vide by ChefSteps'
  description = 'Joule is the sous vide tool that changes everything. Controlled by a groundbreaking custom app, Joule is a sleek, powerful cooking tool that makes sous vide a real part of today’s kitchen.'
  image = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/eP71dY8XQhx1vuvVFNxt'
  MetadataService.set
    title: title
    description: description
    keywords: "joule, sous vide, chefsteps, circulator"
    canonical: canonical
    image: image
    sousVideTargeted: true
    og:
      url: canonical

  this
